<template>
  <div class="valid-code-container">
    <div class="title">
      <span>{{ isLogin ? '登录' : '绑定' }}</span>
      <span class="high-light">智库</span>
    </div>
    <div class="sub-title">{{ isLogin ? '验证即登录，未注册将自动创建帐号' : '绑定手机号' }}</div>
    <div class="form">
      <el-form ref="formRef" :model="loginForm" :rules="formRules">
        <el-form-item prop="phone">
          <div class="inpt-label">手机号</div>
          <el-input v-model="loginForm.phone" placeholder="输入手机号" />
        </el-form-item>
        <el-form-item prop="code">
          <div class="pwd flex flex_col">
            <div class="inpt-label">验证码</div>
            <el-input v-model="loginForm.code" placeholder="输入验证码" type="password" />
            <div class="tip" @click="validateCodePhone" v-if="!showNum">发送验证码</div>
            <div class="count_down" v-else>{{ countDown }} S</div>
          </div>
        </el-form-item>
        <el-form-item align="center">
          <div class="login-btn" @click="loginByPhone">{{ isLogin ? '登录' : '绑定并登录' }}</div>
        </el-form-item>
      </el-form>
      <div class="form-bot">
        <div class="gap-row">或者</div>
        <div class="other-btn flex" v-if="isLogin">
          <div class="btn phone-btn" @click="changeCurrentCom('ValiCodeCom')">账号登录</div>
          <div class="btn code-btn" @click="changeCurrentCom('QrCom')">扫码登录</div>
        </div>
        <div class="bind-count" v-else @click="bindAccountLogin">绑定账号登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import { loginByPhone, validateCodePhoneApi } from '@/apis/index.js'
let timer = null
export default {
  name: 'PhoneNumCom',
  props: {
    isLogin: {
      type: Boolean,
      default: true,
    },
    weixininfo: {
      type: String,
      default: '',
    },

  },
  data() {
    return {
      codeImg: '',
      uuid: '',
      loginForm: {
        productCode: 'TDS',
        username: '',
        password: '',
        cid: '',
        code: '',
        rememberMe: false,
        weixininfo: '',
      },
      RSABase64PublicKey: '', //加密公钥
      formRules: {
        phone: [
          { required: true, message: '不能为空', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '电话号码格式错误',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: ['blur'],
          },
        ],
      },
      showNum: false,
      countDown: 60,
    }
  },
  async mounted() {},
  beforeDestroy(){
    timer = null
    clearInterval(timer)
  },
  methods: {
    loginByPhone() {
      this.$refs.formRef.validate(async (v) => {
        if (!v) return
        this.loginForm.weixininfo = this.weixininfo
        let res = await loginByPhone(this.loginForm)
        if (res.success) {
          this.$emit('loginSuccess', res)
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    validateCodePhone() {
      this.$refs.formRef.validateField(['phone'], async (v) => {
        if (!v) {
          // 没有错误信息----验证通过
          this.$message.success('验证码已发送，请注意查收')
          // 获取短信验证码
          let res = await validateCodePhoneApi(this.loginForm.phone)
          if (res.success) {
            const { uuid, code } = res.data
            this.loginForm.cid = uuid
            this.loginForm.code = code
            this.showNum = true
            this.countDown = 60
            clearInterval(timer)
            timer = setInterval(() => {
              if (this.countDown > 0) {
                this.countDown -= 1
              } else {
                this.showNum = false
              }
            }, 1000)
          } else {
            this.$message.error(res.msg)
          }
        }
      })
    },
    changeCurrentCom(com, loginCom = true) {
      this.$emit('changeCom', com, loginCom)
    },
    bindAccountLogin(){
      this.$emit('changeWxBindCom', 'ValiCodeCom')
    }
  },
}
</script>
<style lang="less" scoped>
.valid-code-container {
  padding: 48px 40px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 10px 10px 10px 10px;
  .title {
    font-weight: bold;
    font-size: 32px;
    color: #03133d;
    line-height: 34px;
    .high-light {
      margin-left: 10px;
      color: #0677e7;
    }
  }
  .sub-title {
    margin-top: 12px;
    font-size: 18px;
    color: #68718b;
    line-height: 24px;
  }
  .form {
    margin-top: 32px;
    /deep/.el-input__inner {
      width: 380px;
      height: 44px;
      line-height: 44px;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #cdd0d8;
    }
    .base64img {
      margin-left: 12px;
      width: 100px;
      height: 38px;
    }
    .inpt-label {
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #03133d;
      line-height: 22px;
    }
    .input {
      /deep/.el-input__inner {
        width: 268px;
      }
    }
    .tip,
    .count_down {
      position: absolute;
      right: 0;
      bottom: -22px;
      font-size: 14px;
      color: #006fba;
      line-height: 20px;
      cursor: pointer;
    }
    .count_down {
      cursor: default;
      color: #8e8e8e;
    }
    .login-btn {
      margin-top: 24px;
      width: 380px;
      height: 54px;
      background: linear-gradient(160deg, #0c87f0 0%, #036fe2 100%);
      border-radius: 10px 10px 10px 10px;
      line-height: 54px;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
    .regist-tip {
      text-align: center;
      font-size: 14px;
      color: #68718b;
    }
    .regist-btn {
      color: #006fba;
      font-weight: bold;
    }
  }
  .form-bot {
    margin-top: 24px;
    .gap-row {
      font-size: 14px;
      color: #68718b;
      &::before {
        content: '';
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 13px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }
      &::after {
        content: '';
        vertical-align: middle;
        margin-left: 13px;
        margin-top: -3px;
        display: inline-block;
        width: 163px;
        height: 1px;
        background-color: #e6e8ec;
      }
    }
    .other-btn {
      margin-top: 24px;
    }
    .btn {
      width: 182px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #e6e8ec;
      cursor: pointer;
    }
    .phone-btn {
      margin-right: 16px;
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 12px;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/login/count.png);
        background-size: contain;
      }
    }
    .code-btn::before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      margin-top: -3px;
      width: 24px;
      height: 24px;
      margin-right: 12px;
      background-image: url(../../../assets/login/qrcode.png);
      background-size: contain;
    }
    .bind-count {
      width: 380px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      border-radius: 10px 10px 10px 10px;
      border: 1px solid #e6e8ec;
      cursor: pointer;
      &::before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        margin-top: -3px;
        margin-right: 12px;
        width: 24px;
        height: 24px;
        background-image: url(../../../assets/login/count.png);
        background-size: contain;
      }
    }
  }
}
</style>
